export default "__VITE_ASSET__EWSCcgCj__"